import { Component } from '@angular/core';
import { NgOptimizedImage } from "@angular/common";
import { Router } from "@angular/router";
import { FormControl, FormGroup, FormsModule, ReactiveFormsModule, Validators } from "@angular/forms";
import { MatButton } from "@angular/material/button";
import { MatInput, MatLabel } from "@angular/material/input";
import { PasswordFieldComponent } from "../../components/password-field/password-field.component";
import { SessionService } from "../../services/session.service";
import { PageLoaderService } from "../../services/page-loader.service";
import { SnackbarService } from "../../services/snackbar.service";
import { signIn, signOut } from "aws-amplify/auth";
import { MatFormField } from "@angular/material/form-field";

/** Root of all the login pages */
@Component({
	selector: 'app-login-index',
	imports: [
		NgOptimizedImage,
		FormsModule,
		MatButton,
		MatFormField,
		MatInput,
		MatLabel,
		PasswordFieldComponent,
		ReactiveFormsModule
	],
	templateUrl: './login-index.component.html',
	styleUrl: './login-index.component.scss'
})
export class LoginIndexComponent {
	/** Login form */
	form = new FormGroup({
		email: new FormControl('', [Validators.required, Validators.email]),
		password: new FormControl('', Validators.required)
	});

	constructor(private router:Router,
	            private sessionService:SessionService,
	            private loaderService:PageLoaderService,
	            private snackbar:SnackbarService) {
	}

	/** Submit the login request */
	async submit() {
		if(this.form.valid) {
			try {
				await signOut();

				this.loaderService.show("Logging in...");

				const response = await signIn({
					username: this.form.value.email,
					password: this.form.value.password
				});

				if(response.nextStep.signInStep == "DONE") {
					await this.sessionService.redirectAfterLogin();
				} else {
					this.snackbar.error("You have another step in your login, sign in to portal to fix");
				}
			} catch(e) {
				console.warn("Failed to login", e);
				this.snackbar.error("Failed to login");
			} finally {
				this.loaderService.close();
			}
		}
	}
}
